import { Axios } from 'utils/AxiosConfig'

export const postResetPasswordByCode = async (payload) => {
  const { data: response } = await Axios.post(`reset-password`, payload)
  return response
}
